module.exports = __webpack_public_path__ + "img/support-rechts.e2a1ea91.jpg";